export default __webpack_public_path__ + "static/media/UG4-rank.51f25493.jpg";